import request from "@/utils/oms-request";
import lmsRequest from "@/utils/request";
import download from "@/utils/oms-download";

export const page: any = (param, page) =>
    request({
        url: "/invoice",
        method: "GET",
        params: {...param, ...page}
    });

export const list: any = (param) =>
    request({
        url: "/invoice/list/bo-code",
        method: "GET",
        params: {...param}
    });

export const pagePaymentVoucher: any = (param, page) =>
    request({
        url: "/payment_voucher/invoice",
        method: "GET",
        params: {...param, ...page}
    });

export const itemList = (param) =>
    request({
        url: "/invoice/items",
        method: "GET",
        params: {...param}
    });

export const invoiceCodeOpts = (param) =>
    request({
        url: "/invoice/receipt_code",
        method: "GET",
        params: {...param}
    });

export const getReconciliationAllocateDetail = (param) =>
    request({
        url: "/invoice/reconciliation_allocate_record",
        method: "GET",
        params: {...param}
    });

export const reconcile = (data) =>
    request({
        url: "/invoice/reconcile",
        method: "POST",
        data
    });

export const bindTuiShui = (data) =>
    request({
        url: "/invoice/bind/tuishui",
        method: "POST",
        data
    });
export const bindNeiXiao = (data) =>
    request({
        url: "/invoice/bind/neixiao",
        method: "POST",
        data
    });
export const bindShouGong = (data) =>
    request({
        url: "/invoice/bind/shougong",
        method: "POST",
        data
    });

export const downloadInvoice = (param) =>
    download({
        responseType: "blob",
        url: "/invoice/download",
        method: "GET",
        params: {...param}
    });
export const updateCertificationDate = (data) =>
    request({
        url: "/invoice/certification_date",
        method: "POST",
        data: data
    });

export const updateRemark = (data) =>
    request({
        url: "/invoice/remark",
        method: "POST",
        data: data
    });

export const remove = (id) =>
    request({
        url: `/invoice/${id}`,
        method: "DELETE",
    });

export const pageInvoiceBookingOrder = (params): any =>
    lmsRequest({
        url: "/declaration-invoice",
        method: "GET",
        params,
    });

// 报关开票管理列表-隐藏模式
export const pageInvoiceBookingOrderNative = (params): any =>
    lmsRequest({
        url: "/declaration-invoice/native",
        method: "GET",
        params,
    });

export const detailInvoiceBookingOrder = (id): any =>
    lmsRequest({
        url: `/declaration-invoice/${id}`,
        method: "GET",
    });
// 报关开票详情-头部信息-native
export const detailInvoiceBookingOrderNative = (id): any =>
    lmsRequest({
        url: `/declaration-invoice/${id}/native`,
        method: "GET",
    })

export const pageInvoiceBookingOrderDetail = (param, page): any =>
    lmsRequest({
        url: "/declaration-invoice/factory-invoices",
        method: "GET",
        params: {...param, ...page}
    });

// 报关开票详情-原生数据
export const pageInvoiceBookingOrderDetailNative = (param, page): any =>
    lmsRequest({
        url: "/declaration-invoice/factory-invoices/native",
        method: "GET",
        params: {...param, ...page}
    });

export const getInvoiceAmountDetail = (param): any =>
    lmsRequest({
        url: "/declaration-invoice/factory-invoice/amount-details",
        method: "GET",
        params: {...param}
    });

export const getDeclarationInvoiceAmountDetail = (param): any =>
    lmsRequest({
        url: "/declaration-invoice/amount-details",
        method: "GET",
        params: {...param}
    });

export const getInvoiceBookingOrderProduct: any = (param) =>
    lmsRequest({
        url: "/declaration-invoice/product",
        method: "GET",
        params: {...param}
    });

export const updateInvoiceBookingOrderRemark = (id, remark) =>
    lmsRequest({
        url: `/declaration-invoice/${id}/remark`,
        method: "PUT",
        params: {remark}
    });

export const updateFactoryInvoiceInvoiceRemark = (id, remark) =>
    lmsRequest({
        url: `/declaration-invoice/${id}/invoice-remark`,
        method: "PUT",
        params: {remark}
    });

export const getReceiptAllocateRecord = (param) =>
    request({
        url: "/invoice/receipt_allocate_record",
        method: "GET",
        params: {...param}
    });

export const pageFactoryInvoice: any = (param, page) =>
    lmsRequest({
        url: "/factory-invoices/invoice",
        method: "GET",
        params: {...param, ...page}
    });
export const pageFactoryLoadingPlan: any = (param, page) =>
    lmsRequest({
        url: "/factory-loading-plans/invoice",
        method: "GET",
        params: {...param, ...page}
    });
export const pageHenganLoadingPlan: any = (param, page) =>
    lmsRequest({
        url: "/hengan-loading-plans/invoice",
        method: "GET",
        params: {...param, ...page}
    });

export const getInvoiceAllocateRecord: any = (param, page) =>
    request({
        url: "/invoice/invoice_allocate_record",
        method: "GET",
        params: {...param, ...page}
    });

export const pageInvoice: any = (param, page) =>
    request({
        url: "/invoice/factory_invoice",
        method: "GET",
        params: {...param, ...page}
    });

export const getInvoiceByFactoryInvoice: any = (param) =>
    request({
        url: "/invoice/factory_invoice/invoice",
        method: "GET",
        params: {...param}
    });
export const pagePurchaseOder: any = (param, page) =>
    request({
        url: "/purchase-order/invoice",
        method: "GET",
        params: {...param, ...page}
    });

// 上传创建发票
export const createInvoice = (data: any) =>
    request({
        url: `/invoice`,
        method: "PUT",
        data: data
    });

export const queryFactoryInvoiceAllocateStatus = () =>
    lmsRequest({
        url: `/declaration-invoice/allocate-status`,
        method: "GET",
    });

// 查询拆资料详情
export const querySplitDetail = (id) =>
    lmsRequest({
        url: `/declaration-invoice/${id}/split`,
        method: "GET",
    });

// 开票资料拆资料
export const splitFactoryInvoice = (id, data) =>
    lmsRequest({
        url: `/declaration-invoice/${id}/split`,
        method: "POST",
        data
    });

// 查询可以换资料的开票资料
export const queryReplaceDetail = (id, params) =>
    lmsRequest({
        url: `/declaration-invoice/${id}/replace`,
        method: "GET",
        params
    });

// 开票资料换资料
export const replaceFactoryInvoice = (id, data) =>
    lmsRequest({
        url: `/declaration-invoice/${id}/replace`,
        method: "PUT",
        data
    });

// 取消换资料
export const revertReplaceFactoryInvoice = (id) =>
    lmsRequest({
        url: `/declaration-invoice/${id}/revert-replace`,
        method: "PUT",
    });

// 原开票资料信息
export const queryOriginalDetail = (params) =>
    lmsRequest({
        url: `/declaration-invoice/original-detail`,
        method: "GET",
        params
    });

// 标记为无发票
export const markAsNoInvoice = (id) =>
    lmsRequest({
        url: `/declaration-invoice/${id}/mark-as-no-invoice`,
        method: "PUT",
    });

// 取消无发票
export const revertMarkAsNoInvoice = (id) =>
    lmsRequest({
        url: `/declaration-invoice/${id}/revert-mark-as-no-invoice`,
        method: "PUT",
    });

// 查询数据模式
export const queryDataSourceMode = () =>
    lmsRequest({
        url: `/declaration-invoice/data-source-mode`,
        method: "GET",
    });

// 更新数据模式
export const updateDataSourceMode = (params) =>
    lmsRequest({
        url: `/declaration-invoice/data-source-mode`,
        method: "PUT",
        params
    })
